import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('mrm_user') || 'null'); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get('/auth/me');
      setUser(r.data);
      localStorage.setItem('mrm_user', JSON.stringify(r.data));
    } catch {
      setUser(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => {
    if (localStorage.getItem('mrm_token')) {
      refresh();
    } else {
      setLoading(false);
    }
  }, [refresh]);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('mrm_token', r.data.token);
    localStorage.setItem('mrm_user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('mrm_token');
    localStorage.removeItem('mrm_user');
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
